import { render } from "./PlayerPicture.vue?vue&type=template&id=a4ec3d84&ts=true"
import script from "./PlayerPicture.vue?vue&type=script&lang=ts"
export * from "./PlayerPicture.vue?vue&type=script&lang=ts"

import "./PlayerPicture.vue?vue&type=style&index=0&id=a4ec3d84&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__